import React, { useState, useEffect } from 'react';
import { MasterDataGrid } from "@/components/";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import IndMasterDetail from '../indicators-master-detail';
import TableErrors from '../table-errors';
import { Enums, Utilities } from "@utils";

export interface IIndicators{
    index: number;
    indicator: any;    
    status: any;
    screen?: string;
    name?: string;
    isDetail?: boolean;
	dataColumns: any;
    currentYear: any;
    saveTable: any;
    tableAlerts?: string;
    columns: any;
    data: any;
    gridTitle: any;
    helpName: any;
    initialValidate: boolean;
}

const DetailIndicator: React.FC<any> = (props: IIndicators) => {
    const [auxData, setAuxData] = useState(null);
    const view: IFollowupSubproject = {
        state: {
            dataColumns: props.dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        if((props.tableAlerts === `${props.data?.id}-${props.index}-${props.name}` || !props.tableAlerts || props.tableAlerts === 'All') && props.data?.data && props.columns) {
            if(presenter.stepTourInd > 1){
                let dataTour = presenter.getTourData(11, Enums.FollowupDimensions.indicators)
                let colTour = presenter.getIndType2Columns({CodigoDimension: Enums.FollowupState.substantialModifications}, props.currentYear)
                
                let asd = getAuxData(dataTour, colTour)
                setAuxData(asd)
            }else{
                let asd = getAuxData()
                setAuxData(asd)
            }
        }
    }, [props.data?.data, props.tableAlerts, props.columns, props.initialValidate, presenter.tourIndSeen, presenter.stepTourInd]); 

    const getAuxData = (tourData?: any, tourCol?: any) => {
        return (
            <div id={"IndicatorsTourStep14"}>
                <TableErrors 
                    initialValidate={props.initialValidate}
                    checkEmptyValues={(item: any) => presenter.checkEmptyValues(item, props.status, Enums.IndicatorType.type2)}
                    msgInitialError={presenter.followupLabels.get("completeFrameworkInformation")}
                    tableAlerts={(presenter.stepTourInd === 14) ? `${props.name}` : props.tableAlerts}
                    calculatedReqFields={(instance: any) => presenter.checkReqFields(instance, props.status)} 
                    calculatedSumPl={(data: any) => presenter.checkAchievement(data, Number(props.currentYear))} 
                    gridId={`${props.name}`} 
                    followupLabels={presenter.followupLabels}
                    tourActive={presenter.stepTourInd === 14}
                />
                {(props.initialValidate && (props.data?.data?.length <= 1)) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.followupLabels.get("alertMinTwoIndicatorsRequired")}</h6>
                    </div>
                }
                <MasterDataGrid
                    id={`${props.name}`}
                    dataSource={tourData || props.data?.data}
                    columns={tourCol || props.columns}
                    keyExpr={"id"}
                    allowCode={props.screen}
                    gridTitle={props.gridTitle}
                    gridHelpId={`tooltip-${props.name}`}
                    gridHelpText={presenter.followupLabels.get("helpProductIndicators")}
                    idTour="IndicatorsTourStep12"
                    gridProps={{
                        editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false,
                        selection:{
                            mode:"single"
                        }
                    }}
                    saveTable={props.saveTable}
                />
                <IndMasterDetail 
                    tourData={tourData ? [tourData?.[0]] : null}
                    data={[]} 
                    status={props.status} 
                    schema={props.data?.schema} 
                    id={`${props.name}-detail`}
                    onSelectionChanged={onselectionchange}  
                    gridId={`${props.name}`}   
                    screen={props.screen}   
                    dataColumns={props.dataColumns}      
                    currentYear={props.currentYear}  
                />          
            </div>
        )
    }

    return (
        <>
            {auxData && auxData}
        </>
    )
}

export default DetailIndicator;